import * as React from "react"
import Svg, {Circle, Path} from "react-native-svg"

const HomeIcon = (props) => (
    <Svg
        width={props.size}
        height={props.size}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Circle cx={11} cy={11} r={10.25} stroke={props.color} strokeWidth={1.5} />
        <Circle cx={11} cy={8.724} r={2.664} stroke={props.color} strokeWidth={1.5} />
        <Path
            d="M3.793 17.828c4.172-4.931 9.862-4.742 14.793 0"
            stroke={props.color}
            strokeWidth={1.5}
        />
    </Svg>
)

export default HomeIcon
